import React from 'react';
import { Player } from '../../../types';

interface PlayerInfoProps {
  player: Player;
  isMobile: boolean;
  isCompact: boolean;
  textColor: string;
  secondaryTextColor: string;
}

const getPositionEmoji = (position: string) => {
  switch (position) {
    case 'Arquero':
      return '🥅';
    case 'Defensor':
      return '🛡️';
    case 'Mediocampista':
      return '⚽';
    case 'Delantero':
      return '🚀';
    default:
      return '👤';
  }
};

export const PlayerInfo: React.FC<PlayerInfoProps> = ({
  player,
  isMobile,
  isCompact,
  textColor,
  secondaryTextColor,
}) => {
  const isDesktop = !isMobile && !isCompact;

  if (isDesktop) {
    // Compact single-line layout for desktop
    return (
      <div style={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', gap: '6px' }}>
        <span style={{
          fontWeight: 'bold',
          fontSize: '13px',
          color: textColor,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: '150px',
        }}>
          {player.name}
        </span>
        <span style={{ color: '#555', fontSize: '11px' }}>·</span>
        <span style={{ fontSize: '12px', flexShrink: 0 }}>
          {getPositionEmoji(player.position)}
        </span>
        <span style={{ fontSize: '11px', color: '#F59E0B', letterSpacing: '-1px', flexShrink: 0 }}>
          {'★'.repeat(player.rating)}{'☆'.repeat(Math.max(0, 5 - player.rating))}
        </span>
        {!player.userId && (
          <span
            title="Invitado: No puede recibir estadísticas ni reviews hasta que se registre"
            style={{ fontSize: '12px', cursor: 'help', flexShrink: 0 }}
          >⚠️</span>
        )}
      </div>
    );
  }

  // Mobile/compact: keep original multi-line layout
  return (
    <div style={{ flex: 1, minWidth: 0 }}>
      <div style={{
        fontWeight: 'bold',
        fontSize: '13px',
        color: textColor,
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        maxWidth: '100%',
        lineHeight: '1.15',
        whiteSpace: 'normal',
        textOverflow: 'clip',
        overflow: 'hidden',
      }}>
        {player.name}
      </div>
      <div style={{ fontSize: '11px', color: secondaryTextColor }}>
        {getPositionEmoji(player.position)} {player.position} • {'★'.repeat(player.rating)}
      </div>
      {!player.userId && (
        <div style={{
          fontSize: '10px',
          color: '#FF9800',
          marginTop: '4px',
          fontStyle: 'italic',
          display: 'flex',
          alignItems: 'center',
          gap: '4px'
        }}>
          <span>⚠️</span>
          <span>Invitado: No puede recibir estadísticas ni reviews hasta que se registre</span>
        </div>
      )}
    </div>
  );
};
